<template>
  <div class="row q-col-gutter-y-sm sai-print-avoid-break-inside">
    <span class="text-grey-8 col-12">{{ subTitle }}</span>
    <span class="text-primary-semi-dark cursor-pointer">
      <span class="text-weight-medium">View car details</span>
      <QMenu
        :value="displayVariantDetails"
        anchor="bottom left"
        self="top left"
        :offset="[0, 8]"
        :max-width="$q.screen.lt.md ? 'calc(100% - 32px)' : '992px'"
        ref="detailsMenu"
      >
        <div class="row q-pa-sm">
          <QSpace />
          <SAIIconBtn @click="$refs.detailsMenu.hide()" />
        </div>
        <SummaryDetails :details="variantDetails" />
      </QMenu>
    </span>

    <CarPriceCard
      class="q-my-md"
      :on-road-cost="onRoadCost"
      :img="saleTagImg"
    />

    <div v-if="imgSrc" class="row justify-center full-width">
      <QImg
        :src="imgSrc"
        alt="Car image"
        class="col-lg-3 col-md-4 col-sm-6 col-xs-9 q-mb-sm"
        contain
        basic
      />
    </div>

    <span
      class="text-grey-5 text-center text-tab text-weight-medium full-width"
      v-if="imgSrc"
    >
      Sample photo only, not actual vehicle
    </span>
  </div>
</template>

<script>
import { QImg, QMenu, QSpace } from 'quasar';
import { SAIIconBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'CarSummary',
  props: {
    modelYear: String,
    make: String,
    model: String,
    variant: String,
    bodyType: String,
    doors: String,
    transmission: String,
    gears: String,
    liters: String,
    imgSrc: String,
    color: String,
    displayVariantDetails: Boolean,
    variantDetails: {
      type: Array,
      default: () => []
    },
    imageCaption: {
      type: String,
      default: 'Sample photo only, not actual vehicle'
    },
    onRoadCost: Number,
    listPrice: Number,
    saleTagImg: String
  },
  computed: {
    fullDoors() {
      return this.doors ? `${this.doors} DR` : '';
    },
    fullSpd() {
      return this.gears ? `${this.gears}sp` : '';
    },
    fullLiters() {
      return this.liters ? `${this.liters}L` : '';
    },
    subTitle() {
      return [
        this.color,
        this.bodyType,
        this.fullDoors,
        this.transmission,
        this.fullSpd,
        this.fullLiters
      ]
        .filter(Boolean)
        .join(' ');
    }
  },
  components: {
    QImg,
    QMenu,
    QSpace,
    SAIIconBtn,
    CarPriceCard: () => import('../../molecule/car-price-card'),
    SummaryDetails: () => import('../summary-details')
  }
};
</script>
